module.exports = __webpack_public_path__ + "img/icon-logout.6b7c842f.svg";